import { apiClient } from "../config";

async function addNewForm(data: any) {
  const res = await apiClient.post(`/admin/dynamic-forms`, data);
  return res.data;
}

export default addNewForm;
